// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store';
import mixin from "./mixin";
import util from './utils/util';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/index.scss'
import './assets/styles/element-variables.scss'

import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let option = {
  maxSpreadZoom: 2,
  getDoubleTapZoom: function (isMouseClick, item) {
    console.log(item)
    return item.initialZoomLevel < 0.85 ? 1 : 2
  }
}
Vue.use(preview, option)
import ElementUI from 'element-ui'
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.mixin(mixin);

import YueUI from 'yuejuan-ui'
Vue.use(YueUI)

import XepUI from 'xep-ui'
Vue.use(XepUI)

import NoData from './components/nodata/index'
Vue.use(NoData)

import VCard from "./components/card/index";
Vue.use(VCard);

Vue.directive('authvalidate', {
  update: function (el, binding) {
    if (!util.isAuth(binding.value)) {
      el.style.display = 'none';
    }
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
